/**
 * @description: upload style enum
 * 上传类型图片返回规则
 */


export const uploadStyleEnum  =  {
  'STYLE_PIC_STD': 'pic_std', // width: 750，通用图片样式
  'STYLE_PIC_WXASHARE': 'pic_wxashare', // width: 750，height: 600 小程序分享图片大小
  'STYLE_ULOGO_STD': 'ulogo_std', // width: 480 x 480
  'STYLE_ULOGO_THUMB': 'ulogo_thumb', // width: 150 x 150
  'STYLE_ROUND_LOGO': 'round_logo', // width: 480 x 480
  'STYLE_GLOGO_LARGE': 'glogo_large', // width: 1080 x 1080
  'STYLE_GLOGO_STD': 'glogo_std', // width: 750 x 750
  'STYLE_GLOGO_THUMB': 'glogo_thumb', // width: 375 x 375
  'STYLE_GOODS_LARGE': 'goods_large', // width: 1080
  'STYLE_GOODS_STD': 'goods_std', // width: 750
  'STYLE_GOODS_THUMB': 'goods_thumb', // width: 375 x 375
  'STYLE_MALL_BANNER': 'mall_banner', // width: 375 x 375
  'STYLE_ORIGINAL': 'original' // 原图
}


export const UPLOAD_PROJECT = 'dsx'
export const UPLOAD_GROUP = 'h5'
